import { Routes, Route } from "react-router-dom";
import CustomerUpdateOverview from "view/customerUpdate/CustomerUpdateOverview";

const index = () => {
	return (
		<Routes>
			<Route index element={<CustomerUpdateOverview />} />
		</Routes>
	);
};

export default index;
